export const backgroundStyleFromVisualConfig = (
	visualConfig:
		| {
				backgroundColor: string | null | undefined;
				backgroundImage: { url: string | null | undefined } | null | undefined;
				backgroundType: 'COLOR' | 'IMAGE' | 'TRANSPARENT' | string | null | undefined;
		  }
		| null
		| undefined,
	fallBack?: {
		backgroundColor?: string;
		backgroundImageUrl?: string;
	},
) => {
	let backgroundColor: string;
	let backgroundImageUrl: string | undefined;

	switch (visualConfig?.backgroundType) {
		case 'COLOR':
			backgroundColor = visualConfig.backgroundColor || fallBack?.backgroundColor || 'transparent';
			backgroundImageUrl = undefined;
			break;
		case 'IMAGE':
			backgroundColor = visualConfig.backgroundColor || 'transparent';
			backgroundImageUrl =
				visualConfig.backgroundImage?.url || fallBack?.backgroundImageUrl || undefined;
			break;
		default:
			backgroundColor = 'transparent';
			backgroundImageUrl = undefined;
			break;
	}

	return {
		backgroundColor,
		backgroundImage: backgroundImageUrl,
	};
};
